import { useEffect, useState } from 'react';
import equal from 'fast-deep-equal';
import {
  readShopifyConsent,
  SHOPIFY_CONSENT_READY_EVENT,
} from './shopifyTracking';

export function useShopifyConsent() {
  const [consent, setConsent] = useState(null);

  useEffect(() => {
    let interval;
    const syncConsent = () => {
      const next = readShopifyConsent();
      setConsent((previous) => (equal(previous, next) ? previous : next));
      if (next) window.clearInterval(interval);
    };
    // The existing privacy script loads asynchronously. Pending is distinct
    // from denied: never delete valid cookies while waiting for initialization.
    interval = window.setInterval(syncConsent, 250);
    const timeout = window.setTimeout(
      () => window.clearInterval(interval),
      15000
    );
    document.addEventListener('visitorConsentCollected', syncConsent);
    document.addEventListener(SHOPIFY_CONSENT_READY_EVENT, syncConsent);
    document.addEventListener('load', syncConsent, true);
    window.addEventListener('pageshow', syncConsent);
    window.addEventListener('focus', syncConsent);
    syncConsent();
    return () => {
      window.clearInterval(interval);
      window.clearTimeout(timeout);
      document.removeEventListener('visitorConsentCollected', syncConsent);
      document.removeEventListener(SHOPIFY_CONSENT_READY_EVENT, syncConsent);
      document.removeEventListener('load', syncConsent, true);
      window.removeEventListener('pageshow', syncConsent);
      window.removeEventListener('focus', syncConsent);
    };
  }, []);

  return consent;
}
